import { PdsrClientViewModel } from "../../ViewModel/PdsrClientViewModel";

export const getPdsrOnRouteById = (
  pdsrsOnThisRoute: Array<PdsrClientViewModel>,
  pdsrId: number
) => {
  return pdsrsOnThisRoute.find((pdsr) => pdsr.PdsrId === pdsrId);
};
